import React, { Component } from 'react';
import CustomInput from '../../../../Utility/Components/CustomInput';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Utility from '../../../../Utility/Utility';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import Config from '../../../../Utility/Config';
import CustomButton from "../../../../Utility/Components/CustomButton"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Popover from 'react-bootstrap/Popover';

function WebhookSettingsModalContent(props) {
    return (
        <div className="modalinnerbody">
            <div className="col-md-12 input_section">
                <ErrorBoundary title="CustomInput Error">
                    <OverlayTrigger overlay={<Tooltip>{props.webhookSettingText.fb_token_text}</Tooltip>} placement='bottom'>
                        <CustomInput
                            labelName="Token"
                            parentClassName="input_field_inner"
                            labelPresent={true}
                            name="text_button"
                            type="text"
                            value={props.webhookSettingText.fb_token_text}
                            onChange={(e) => { props.handleChangeTextWebhook(e, "fb_token_text") }}
                            requiredStar={true}
                            readOnly={true}
                        // errorLabel={props.webhookSettingError.fb_token_error}
                        />
                    </OverlayTrigger>
                    <div className="errorClass error_div">{props.webhookSettingError.fb_token_error}</div>
                </ErrorBoundary>
            </div>
            <div className="col-md-12 input_section">
                <ErrorBoundary title="CustomInput Error">
                    <CustomInput
                        labelName="WhatsApp Business Account ID"
                        parentClassName="input_field_inner"
                        labelPresent={true}
                        name="text_button"
                        type="text"
                        value={props.webhookSettingText.client_id_text}
                        onChange={(e) => { props.handleChangeTextWebhook(e, "client_id_text") }}
                        requiredStar={true}
                        readOnly={true}
                    // errorLabel={props.webhookSettingError.client_id_error}
                    />
                    <div className="errorClass error_div">{props.webhookSettingError.client_id_error}</div>
                </ErrorBoundary>
            </div>
            <div className="col-md-12 input_section">
                <ErrorBoundary title="CustomInput Error">
                    <CustomInput
                        labelName="Whatsapp Phone Number Id"
                        parentClassName="input_field_inner"
                        labelPresent={true}
                        name="text_button"
                        type="text"
                        value={props.webhookSettingText.whatsapp_account_id_text}
                        onChange={(e) => { props.handleChangeTextWebhook(e, "whatsapp_account_id_text") }}
                        requiredStar={true}
                        readOnly={true}
                    // errorLabel={props.webhookSettingError.whatsapp_account_id_error}
                    />
                    <div className="errorClass error_div">{props.webhookSettingError.whatsapp_account_id_error}</div>
                </ErrorBoundary>
            </div>
            <div className="col-md-12 input_section">
                <ErrorBoundary title="CustomInput Error">
                    <CustomInput
                        labelName="Call Back API"
                        parentClassName="input_field_inner"
                        labelPresent={true}
                        name="text_button"
                        type="text"
                        value={props.webhookSettingText.event_call_back_api_text}
                        onChange={(e) => { props.handleChangeTextWebhook(e, "event_call_back_api_text") }}
                        requiredStar={true}
                    // errorLabel={props.webhookSettingError.event_call_back_api_error}
                    />
                    <div className="errorClass error_div">{props.webhookSettingError.event_call_back_api_error}</div>
                </ErrorBoundary>
            </div>
        </div>
    )
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
    };
}

export default withRouter(connect(mapStateToProps, {})(withTranslation()(WebhookSettingsModalContent)));
